<!-- eslint-disable curly -->
<script setup lang="ts">
import { getSettings } from './server/settings'
import { updateSettings, useSettings } from './composables/settings'
import { promptInjectKey } from './pages/prompt/[id]/@types/inject'
import { setEnterprise } from './composables/enterprise'
import { useElementalElementalTypesQuery } from './composables/query/elementalTypes/getElementalTypesQuery'
import { SEO } from './utils/constants'
import ConfirmDialog from './components/ConfirmDialog/index.vue'

const jsonld = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  'name': 'SnackPrompt',
  'url': 'https://snackprompt.com',
  'description': SEO.description,
}

useHead({
  script: [
    {
      hid: 'organization-json-ld',
      type: 'application/ld+json',
      innerHTML: JSON.stringify(jsonld),
    },
  ],
})

provide(promptInjectKey, {})
// TODO: if this code starts calling the API, the `await` must be
const { suspense } = useElementalElementalTypesQuery()
await suspense()
onMounted(async () => {
  useDebugModeListener()
  setupExtensionListener()
  setupDefaultPromptType()
  useFeatureFlags()
  const user = useUser()
  const settings = useSettings()

  updateSettings(await getSettings())

  watch(user, (user) => {
    const followedTopics = useFollowedTopics()

    if (user) {
      loadFollowedTopics()
      // loadFollowingUsers()
    }
    else {
      followedTopics.value = []
    }
  })

  watch(settings, (currentSettings) => {
    if (currentSettings && currentSettings.mainApiMaintenanceMode)
      showError({ statusCode: 503, message: 'Maintenance', fatal: true })
  })

  const route = useRoute()
  if (!isNaN(Number(route.query.enterprise_id)))
    setEnterprise(Number(route.query.enterprise_id))
})
const runtimeConfig = useRuntimeConfig()
const isProduction = computed(() => runtimeConfig.public.environment === 'PROD')
</script>

<template>
  <Html lang="en">
    <Body class="overflow-hidden">
      <NuxtPage />
      <ClientOnly>
        <ConfirmDialog />
      </ClientOnly>
    </Body>

    <ClientOnly v-if="isProduction">
      <Script id="hs-script-loader" type="text/javascript" async defer src="//js.hs-scripts.com/46107051.js" />

      <Script data-allow-mismatch>
        (function(h,o,t,j,a,r){
        h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
        h._hjSettings={hjid:5131858,hjsv:6};
        a=o.getElementsByTagName("head")[0];
        r=o.createElement('script');r.async=1;
        r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
        a.appendChild(r);
        })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
      </Script>

      <Script defer data-allow-mismatch>
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','GTM-TPM33NN');
      </Script>

      <NoScript data-allow-mismatch>
        <iframe
          src="https://www.googletagmanager.com/ns.html?id=GTM-TPM33NN" height="0" width="0"
          style="display:none;visibility:hidden"
        />
      </NoScript>
    </ClientOnly>

    <Script
      v-if="runtimeConfig.public.enablePublift && !$route.path.includes('/prompt/') && !$route.path.startsWith('/chat')"
      src="https://cdn.fuseplatform.net/publift/tags/2/3240/fuse.js" defer
    />
  </Html>
</template>
